export default __webpack_public_path__ + "static/media/WinterClothes_17.6ca4fad6.png";